import React from "react";
import HeaderMenu from "./HeaderMenu";

function Header(props) {
  //console.log('props: ', props.hashtag);
  let menu = [];
  for (var key in props.hashtag) {
    menu.push({ name: key, data: props.hashtag[key] });
  }
  let menu_items = menu.map((item) => {
    return <HeaderMenu key={item.name} name={item.name} data={item.data} />;
  });
  //console.log(menu);

  return (
    <header id="index" style={{ marginBottom: "1.5rem" }}>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="#index">
            Gravitsappa
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">{menu_items}</ul>
            
              <button onClick={ () => props.reset() } className="btn btn-outline-secondary">
                Reset
              </button>
            
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
